import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import GlobalState, { changeCoopState } from '../../../stores/GlobalState'
import { SolutionTab } from '../../pages/about/Solutions'
import { ReactComponent as Close } from '../../../assets/track/close.svg'
import { ReactComponent as Share } from '../../../assets/track/link01.svg'
import { ReactComponent as Logo } from '../../../assets/about/small-logo.svg'
import IMask from 'imask'
import TextareaAutosize from 'react-textarea-autosize'
import './index.scss'
import SubList from '../../pages/about/SubList'
import { runInAction } from 'mobx'
import ContentState from '../../../stores/ContentState'
import { useLocation } from 'react-router'
import { FormState } from '../../pages/things/Arrange'

const Coop = observer(() => {
  const [width, setWidth] = useState(window.innerWidth)
  const { pathname } = useLocation()
  const inputRef = useRef<any>(null)
  const [tab, setTab] = useState(0)
  const [showMod, setShow] = useState(false)
  const [state, setState] = useState({
    fullname: '',
    phone: '',
    email: '',
    topic: '',
    message: '',
    website: '',
    company: '',
    position: '',
    file: undefined,
  })

  const [errs, setErrs] = useState({
    email: '',
    topic: '',
    msg: '',
    phone: '',
  })

  useEffect(() => {
    let vh = window.innerHeight * 0.01
    const screens = document.querySelector('.coop-pop')
    ;(screens as HTMLElement)?.style.setProperty('--vh', `${vh}px`)
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth)
      let vh = window.innerHeight * 0.01
      const screens = document.querySelector('.coop-pop')
      ;(screens as HTMLElement)?.style.setProperty('--vh', `${vh}px`)
    })
  }, [])

  useEffect(() => {
    if (GlobalState.isCoopShow) {
      document.querySelector('body, html, #root')?.classList.add('hidden-menu')
    } else
      document
        .querySelector('body, html, #root')
        ?.classList.remove('hidden-menu')
  }, [GlobalState.isCoopShow])

  const change = (showMod: boolean) => {
    document.querySelector('.coop-pop')?.classList.remove('show')
    document.querySelector('.coop-pop')?.classList.add('close')

    if (!showMod) {
      setTimeout(() => {
        document.querySelector('.coop-pop')?.classList.add('hidden-pop')
      }, 300)
      setTimeout(() => {
        document.querySelector('.coop-pop')?.classList.remove('show')
        changeCoopState()
      }, 500)
    }
  }

  useEffect(() => {
    document.querySelector('.coop-pop')?.classList.add('show')
  }, [])

  const getFileSize = () => {
    const size = (state.file as any).size
    let res = 0,
      end = 'kb'
    if (size / 1000 > 1 && size / 1000000 < 1) {
      res = size / 1000
      end = 'kb'
    } else if (size / 1000000 > 1) {
      res = size / 1000000
      end = 'mb'
    }

    return `${res.toFixed(2)}${end}`
  }

  const isEmail = (email: string) => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email,
    )
  }

  const submit = () => {
    const phoneError = GlobalState.currentLocale.lang.includes('En')
      ? 'Enter your phone'
      : 'Необхідно заповнити номер телефону'

    const ers: any = {
      email: !state.email.length
        ? ContentState.coop?.emptyEmail
        : state.email.length && !isEmail(state.email)
        ? ContentState.coop?.incorrectEmail
        : '',
      topic: !state.topic.length ? ContentState.coop?.emptyTopic : '',
      msg: !state.message.length ? ContentState.coop?.emptyMsg : '',
      phone: !state.phone.length ? phoneError : '',
    }

    console.log()

    if (
      ers.topic.length ||
      ers.email.length ||
      ers.msg.length ||
      ers.phone.length
    ) {
      setErrs(ers)
      return
    } else {
      const fd = new FormData()
      fd.append('fullname', state.fullname)
      fd.append('phone', state.phone)
      fd.append('message', state.message)
      fd.append('website', state.website)
      fd.append('company', state.company)
      fd.append('position2', state.position)
      state.file && fd.append('file', state.file!, (state.file as any).name)
      fd.append('email', state.email)
      fd.append('topic', state.topic)
      fd.append('status', 'coop')
      fetch(GlobalState.domain, {
        method: 'POST',
        body: fd,
      }).then(() => {
        change(true)
        setShow(true)

        switch (FormState.link) {
          case 'freight':
            ;(window as any).dataLayer = (window as any).dataLayer || []
            ;(window as any).dataLayer.push({ event: 'freight_form' })
            break
          case 'mizhnarodnyi-khab':
            ;(window as any).dataLayer = (window as any).dataLayer || []
            ;(window as any).dataLayer.push({ event: 'consolidated_form' })
            break
          case 'end2end-dostavka':
            ;(window as any).dataLayer = (window as any).dataLayer || []
            ;(window as any).dataLayer.push({ event: 'e-com_form' })
            break
        }

        if (pathname.includes('about') || pathname.includes('contact')) {
          ;(window as any).dataLayer = (window as any).dataLayer || []
          ;(window as any).dataLayer.push({ event: 'cooperation_form' })
        }
      })
    }
  }

  useEffect(() => {
    if (state.topic.length) {
      setErrs({ ...errs, topic: '' })
    }
  }, [state.topic])
  useEffect(() => {
    if (state.email.length && isEmail(state.email)) {
      setErrs({ ...errs, email: '' })
    }
  }, [state.email])

  useEffect(() => {
    if (state.phone.length) {
      setErrs({ ...errs, phone: '' })
    }
  }, [state.phone])
  useEffect(() => {
    if (state.message.length) {
      setErrs({ ...errs, msg: '' })
    }
  }, [state.message])

  useEffect(() => {
    if (!showMod) return

    setTimeout(() => {
      const track = document.querySelector('.coop-pop__final-dash.left')
      if (!track) return
      track.classList.add('animated')

      const resizeObserver1 = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentBoxSize) {
            if (entry.contentBoxSize[0]) {
              if (width > 768) {
                const width = entry.contentBoxSize[0].inlineSize
                const parentWidth = track.parentElement!.getBoundingClientRect()
                  .width

                const right = document.querySelector(
                  '.coop-pop__final-dash.right',
                )
                if (!right) return

                if (width == parentWidth || width / parentWidth > 0.9) {
                  right.classList.add('animated')
                }
              } else {
                const height = entry.contentBoxSize[0].blockSize
                const parentWidth = track.parentElement!.getBoundingClientRect()
                  .height

                const right = document.querySelector(
                  '.coop-pop__final-dash.right',
                )
                if (!right) return
                if (height == parentWidth || height / parentWidth > 0.9) {
                  right.classList.add('animated')
                }
              }
            }
          }
        }
      })
      resizeObserver1.observe(track)

      const track2 = document.querySelector('.coop-pop__final-dash.right')
      if (!track2) return

      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentBoxSize) {
            if (entry.contentBoxSize[0]) {
              if (width > 768) {
                const width = entry.contentBoxSize[0].inlineSize
                const parentWidth = track2.parentElement!.getBoundingClientRect()
                  .width
                if (width == parentWidth || width / parentWidth > 0.9) {
                  setTimeout(() => {
                    document
                      .querySelector('.coop-pop')
                      ?.classList.add('hidden-pop')
                  }, 4000)

                  setTimeout(() => {
                    runInAction(() => {
                      GlobalState.isCoopShow = false
                    })
                  }, 4500)
                }
              } else {
                const height = entry.contentBoxSize[0].blockSize
                const parentWidth = track2.parentElement!.getBoundingClientRect()
                  .height

                if (height == parentWidth || height / parentWidth > 0.9) {
                  setTimeout(() => {
                    document
                      .querySelector('.coop-pop')
                      ?.classList.add('hidden-pop')
                  }, 4000)

                  setTimeout(() => {
                    runInAction(() => {
                      GlobalState.isCoopShow = false
                    })
                  }, 4500)
                }
              }
            }
          }
        }
      })
      resizeObserver.observe(track2)
    }, 300)
  }, [showMod])

  if (!ContentState.coop) return <></>

  return (
    <section
      className={classNames('coop-pop', showMod && 'modal')}
      onClick={() => {
        if (!showMod) {
          change(showMod)
        }
      }}
    >
      {!showMod && GlobalState.isCoopShow ? (
        <div
          className="coop-pop__container"
          onClick={(e) => e.stopPropagation()}
        >
          <form
            className={classNames('coop-pop__cont animate')}
            autoComplete="off"
          >
            <div
              onClick={() => {
                change(showMod)
              }}
              className="coop-pop__close"
            >
              <Close />
            </div>

            <div
              className="coop-pop__title"
              dangerouslySetInnerHTML={{ __html: ContentState.coop!.title }}
            ></div>
            <div
              className="coop-pop__text"
              dangerouslySetInnerHTML={{ __html: ContentState.coop!.text }}
            ></div>
            <div className="we-block__solutions-tabs">
              {ContentState.coop!.tabs.map((s, i) => (
                <SolutionTab
                  title={ContentState.coop!.tabs[i]}
                  key={i}
                  active={tab == i}
                  setTab={(value) => {
                    setTab(i)
                  }}
                />
              ))}
            </div>
            <div className={classNames('coop-pop__row', !tab && 'business')}>
              <div className="coop-pop__col">
                <CoopInput
                  isEmail={false}
                  wordCheck={true}
                  phoneCheck={false}
                  label={ContentState.coop!.fullname}
                  errs={''}
                  state={state.fullname}
                  setState={(value) => setState({ ...state, fullname: value })}
                />
                {!tab && (
                  <>
                    <CoopInput
                      label={ContentState.coop!.company}
                      errs={''}
                      state={state.company}
                      setState={(value) =>
                        setState({ ...state, company: value })
                      }
                    />
                    <CoopInput
                      wordCheck={true}
                      label={ContentState.coop!.position}
                      errs={''}
                      state={state.position}
                      setState={(value) =>
                        setState({ ...state, position: value })
                      }
                    />
                  </>
                )}
              </div>
              <div className="coop-pop__col">
                <PhoneInput
                  label={ContentState.coop!.phone}
                  errs={errs.phone}
                  state={state.phone}
                  setState={(value) => setState({ ...state, phone: value })}
                />

                <EmailInput
                  label={'Email'}
                  errs={errs.email}
                  state={state.email}
                  setState={(value) => setState({ ...state, email: value })}
                />

                {!tab && (
                  <CoopInput
                    label={ContentState.coop!.website}
                    errs={''}
                    phoneCheck={false}
                    isEmail={false}
                    state={state.website}
                    setState={(value) => setState({ ...state, website: value })}
                  />
                )}
              </div>
            </div>

            <SubList
              err={errs.topic}
              defaultValue={ContentState.coop!.topic}
              dt={
                tab
                  ? ContentState.coop!.privatetopics
                  : ContentState.coop!.businessTopic
              }
              state={state.topic}
              setState={(value) => setState({ ...state, topic: value })}
            />
            <div
              className={classNames(
                'coop-pop__input msg-block',
                state.message.length && 'fill',
                errs.msg.length && 'error',
              )}
            >
              <label>
                <span className="coop-pop__label textarea">
                  {ContentState.coop!.yourmessage}
                </span>
                <TextareaAutosize
                  maxRows={5}
                  onChange={(e) =>
                    setState({ ...state, message: e.target.value })
                  }
                ></TextareaAutosize>
              </label>
            </div>
            <div className="coop-pop__bottom-block">
              {!state.file && (
                <label className="button white grey-border">
                  <Share />
                  {ContentState.coop!.addfile}
                  <input
                    type={'file'}
                    accept=".doc,.docx,.pdf"
                    onChange={(e) => {
                      if (!e.target!.files) return
                      setState({ ...state, file: (e.target!.files[0] as any)! })
                    }}
                  />
                </label>
              )}
              {state.file && (
                <div className="coop-pop__file">
                  <div className="coop-pop__file-name">
                    {(state.file as any)?.name.length > 27
                      ? `${(state.file as any)?.name.slice(0, 27)}...`
                      : (state.file as any)?.name}
                  </div>
                  <div className="coop-pop__file-size">{getFileSize()}</div>
                  <div
                    className="coop-pop__file-del"
                    onClick={() => {
                      setState({ ...state, file: undefined })
                    }}
                  >
                    <Close />
                  </div>
                </div>
              )}
              {errs.topic.length ||
              errs.email.length ||
              errs.msg.length ||
              errs.phone.length ? (
                <div className="coop-pop__errors">
                  {errs.topic.length ? (
                    <div className="coop-pop__error">{errs.topic}</div>
                  ) : (
                    <></>
                  )}
                  {errs.phone.length ? (
                    <div className="coop-pop__error">{errs.phone}</div>
                  ) : (
                    <></>
                  )}
                  {errs.email.length ? (
                    <div className="coop-pop__error">{errs.email}</div>
                  ) : (
                    <></>
                  )}
                  {errs.msg.length ? (
                    <div className="coop-pop__error">{errs.msg}</div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
              <div className="button black" onClick={submit}>
                {ContentState.coop!.send}
              </div>
            </div>
          </form>
        </div>
      ) : (
        <></>
      )}
      <section
        className={classNames(
          'coop-pop__final',
          showMod && 'show',
          !showMod && 'hidden',
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          onClick={() => {
            document.querySelector('.coop-pop__final')?.classList.add('hidden')
            setTimeout(() => {
              changeCoopState()
            }, 500)
          }}
          className="coop-pop__close"
        >
          <Close />
        </div>
        <div className="coop-pop__final-top">
          <div className="coop-pop__final-line">
            <div className="coop-pop__final-dash left"></div>
          </div>
          <div className="coop-pop__final-middle">
            <Logo className="coop-pop__final-logo" />
            {ContentState.coop!.thanks.title}
          </div>
          {width <= 768 && (
            <div className="coop-pop__final-text">
              {ContentState.coop!.thanks.text}
            </div>
          )}
          <div className="coop-pop__final-line">
            <div className="coop-pop__final-dash right"></div>
          </div>
        </div>
        {width > 768 && (
          <div className="coop-pop__final-text">
            {ContentState.coop!.thanks.text}
          </div>
        )}
      </section>
    </section>
  )
})

export default Coop

export const CoopInput = ({
  errs,
  state,
  setState,
  label,
  isEmail = false,
  phoneCheck = false,
  wordCheck = false,
}: {
  errs: any
  state: any
  setState: (val: any) => void
  label: string
  isEmail?: boolean
  phoneCheck?: boolean
  wordCheck?: boolean
}) => {
  const [st, setSt] = useState(state)
  const [isFocus, setFocus] = useState(false)

  const checkText = (str: string) => {
    return /([^0-9])$/.test(str)
  }

  useEffect(() => {
    setSt(state)
    if (state.length) {
      setFocus(true)
    } else setFocus(false)
  }, [state])

  return (
    <div
      className={classNames(
        'coop-pop__input',
        errs.length && 'error',
        state.length && !errs.length && 'fill',
        isFocus && 'focused',
      )}
    >
      <label>
        <span className="coop-pop__label">{label}</span>

        <input
          autoComplete="off"
          className={classNames('input')}
          onChange={(e) => {
            if (!e.target.value.length) {
              setState(e.target.value)
              setSt(e.target.value)

              return
            }

            if (wordCheck && checkText(e.target.value)) {
              setState(e.target.value)
              setSt(e.target.value)
            } else if (!phoneCheck && !wordCheck) {
              setState(e.target.value)
              setSt(e.target.value)
            }
          }}
          value={st}
          onFocus={() => setFocus(true)}
          onBlur={() => {
            if (!state.length) setFocus(false)
          }}
        />
      </label>
    </div>
  )
}

export const PhoneInput = ({
  errs,
  state,
  label,
  setState,
}: {
  errs: any
  state: any
  label: any
  setState: (value: string) => void
}) => {
  const inputRef = useRef<any>(null)
  const [isFocus, setFocus] = useState(false)

  const phoneText = (str: string) => {
    return /([0-9-\s+]+)$/.test(str)
  }

  useEffect(() => {
    if (state.length) {
      setFocus(true)
    }
  }, [state])

  useEffect(() => {
    if (!inputRef.current) return

    let mask: any = null
    mask = IMask(inputRef.current, {
      mask: '{00}-00[0]-000-00[-00][-00][-00]',
    })
      .on('accept', () => {
        //setState(mask.value)
      })
      .on('complete', () => {
        setState(mask.value)
      })
    mask.updateValue()
    return () => {
      mask?.destroy()
    }
  }, [state])

  return (
    <div
      className={classNames(
        'coop-pop__input',
        errs.length && 'error',
        state.length && !errs.length && 'fill',
        isFocus && 'focused',
      )}
    >
      <label>
        <span className="coop-pop__label">{label}</span>
        <input
          ref={inputRef}
          className={classNames('input', '')}
          autoComplete="off"
          onChange={(e) => {
            setState(e.target.value)
          }}
          value={state}
          onFocus={() => setFocus(true)}
          onBlur={() => {
            if (!state.length) setFocus(false)
          }}
        />
      </label>
    </div>
  )
}

export const EmailInput = ({
  errs,
  state,
  label,
  setState,
}: {
  errs: any
  state: any
  label: any
  setState: (value: string) => void
}) => {
  const inputRef = useRef<any>(null),
    mask = useRef<any>(null)

  const [isFocus, setFocus] = useState(false)

  // const [value, setValue] = useState('')
  //'__@__.__'

  const changeValue = (e: any) => {
    var isCharsetPresent = true,
      maskedLetter = '_',
      placeholder = '__@__.__',
      value = e,
      l = placeholder.length,
      newValue = '',
      i,
      j,
      isInt,
      isLetter,
      strippedValue,
      matchesNumber,
      matchesLetter

    if (!value.length) {
      setValue('') //'__@__.__'
    }

    if (!value.includes('_') && value.length >= placeholder.length) {
      setValue(value)
      return
    }
    // strip special characters
    strippedValue = value.replace(/\_/g, '')
    strippedValue = strippedValue.replace(/\./g, '')
    strippedValue = strippedValue.replace(/\@/g, '')

    for (i = 0, j = 0; i < l; i++) {
      isInt = !isNaN(parseInt(strippedValue[j]))
      isLetter = strippedValue[j] ? strippedValue[j].match(/[A-Z]/i) : false
      matchesLetter = maskedLetter.indexOf(placeholder[i]) >= 0

      if (isCharsetPresent && matchesLetter && isLetter) {
        newValue += strippedValue[j++]
      } else if (isCharsetPresent && matchesLetter && !isLetter) {
        return newValue
      } else {
        newValue += placeholder[i]
      }
      // break if no characters left and the pattern is non-special character
      if (strippedValue[j] == undefined) {
        break
      }
    }
    setValue(value)
  }

  // useEffect(() => {
  //   setValue(state)
  // }, [state])
  // useEffect(() => {
  //   if (value.length) {
  //     setFocus(true)
  //   }
  //   if (!value.includes('_')) {
  //     setState(value)
  //   }
  // }, [value])
  const [value, setValue] = useState(state)

  const isEmail = (email: string) => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email,
    )
  }
  useEffect(() => {
    if (value.length && isEmail(value)) {
      setState(value)
    }
  }, [value])
  useEffect(() => {
    if (state.length) {
      setFocus(true)
    } else setFocus(false)
  }, [state])

  return (
    <div
      className={classNames(
        'coop-pop__input',
        errs.length && 'error',
        state.length && !errs.length && 'fill',
        isFocus && 'focused',
      )}
    >
      <label>
        <span className="coop-pop__label">{label}</span>
        {/* <input className="input-hidden" /> */}
        <input
          className={classNames('input', 'email')}
          type="email"
          autoComplete="off"
          placeholder={isFocus ? '__@__.__' : ''}
          onChange={(e) => {
            if (!e.target.value.length) {
              setState(e.target.value)
              return
            }

            if (
              new RegExp(
                /^[a-zA-Z0-9]+(\.)?(_)?([a-zA-Z0-9]+)?(@)?([a-zA-Z]+)?(\.)?([a-zA-Z]+)?$/,
              ).test(e.target.value)
            ) {
              setState(e.target.value)
            }

            // changeValue(e.target.value)
            // if (isEmail(e.target.value)) {
            // setState(e.target.value)
            // setValue(e.target.value)
            // }
          }}
          value={state}
          onFocus={() => setFocus(true)}
          onBlur={() => {
            if (!state.length) setFocus(false)
          }}
        />
      </label>
    </div>
  )
}
